import React from 'react';

import AppLayout from './screens/AppLayout';

function App() {
  return <AppLayout />;
}

export default App;
